import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_LOCALE, DEFAULT_LOCALE_BY_LANGUAGE, DEFAULT_LOCALE_KEY } from "@faire/web--source/common/consts/DEFAULT_LOCALE";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { LocalizationCacheStore } from "@faire/web--source/common/localization/LocalizationCacheStore";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { createIntl } from "@formatjs/intl/lib/src/create-intl";
import { createFormatMessage } from "./createFormatMessage";
import { buildLocale } from "./utils";
/**
 * This store exposes the `localeKey` and `currencyFormatLocale` global properties.
 *
 * @deprecated use `useLocalization` from `@faire/web--source/common/localization/useLocalization` instead
 */
export var LocalizationStore = /*#__PURE__*/function () {
  function LocalizationStore() {
    var _this = this,
      _this$localeKey4;
    _classCallCheck(this, LocalizationStore);
    // The CLI needs this to create users for some reason
    this._shouldPassThrough = false;
    this.readCachedIntlOrSetIfUndefined = function (locale) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cachedIntl = LocalizationCacheStore.get().getCachedIntl(locale);
      if (cachedIntl) {
        _this._intl = cachedIntl.intl;
      } else {
        _this._intl = createIntl(_objectSpread({
          locale: locale,
          defaultLocale: DEFAULT_LOCALE,
          messages: {}
        }, config), LocalizationCacheStore.get().cache);
        LocalizationCacheStore.get().setCachedIntl(locale, _this._intl);
      }
    };
    this.initSpecialModes = function () {
      var _this$localeKey, _this$localeKey2;
      if (((_this$localeKey = _this.localeKey) === null || _this$localeKey === void 0 ? void 0 : _this$localeKey.language) === Language.STRING_ID || ((_this$localeKey2 = _this.localeKey) === null || _this$localeKey2 === void 0 ? void 0 : _this$localeKey2.language) === Language.GIBBERISH) {
        var formatMessage = createFormatMessage(_this.localeKey, _this._intl.formatMessage);
        _this._intl = _objectSpread(_objectSpread({}, _this._intl), {}, {
          formatMessage: formatMessage
        });
      }
    };
    this.enableGibberishMode = function () {
      var _this$localeKey3;
      _this._localeKey = DEFAULT_LOCALE_BY_LANGUAGE[Language.GIBBERISH];
      var locale = buildLocale((_this$localeKey3 = _this.localeKey) !== null && _this$localeKey3 !== void 0 ? _this$localeKey3 : DEFAULT_LOCALE_KEY);
      _this.initializeIntl({
        locale: locale,
        messages: {}
      });
      _this.initSpecialModes();
    };
    // We need to recreate the intl object in order to load in new messages
    this.initializeIntl = function (args) {
      _this._currencyFormatLocale = args.currencyFormatLocale;
      _this.readCachedIntlOrSetIfUndefined(args.locale, {
        messages: args.messages
      });
    };
    /**
     * Translate the given message-resolution function in a context that uses the
     * given locale (by temporarily replacing the global Locale context).
     */
    this.translate = function (message, locale, messages) {
      var currentIntl = _this._intl;
      var resolved;
      try {
        _this.readCachedIntlOrSetIfUndefined(locale, {
          messages: messages
        });
        resolved = message();
      } finally {
        _this._intl = currentIntl;
      }
      return resolved;
    };
    this.setPassThrough = function () {
      _this._shouldPassThrough = true;
      // In the event that we want to bypass localization altogether, this
      // will likely only be applicable in node environments where we want
      // to ignore formatjs + dynamic ID generation.
      _this._intl = _objectSpread(_objectSpread({}, _this._intl), {}, {
        formatMessage: function formatMessage(descriptor) {
          return descriptor.defaultMessage;
        }
      });
    };
    this._localeKey = getGlobalProperty("localeKey");
    var locale = buildLocale((_this$localeKey4 = this.localeKey) !== null && _this$localeKey4 !== void 0 ? _this$localeKey4 : DEFAULT_LOCALE_KEY);
    this.readCachedIntlOrSetIfUndefined(locale, {
      // We set defaultLocale as locale since we inline translations so falling back to default
      // is the same as falling back to our chosen locale
      defaultLocale: locale
    });
    this.initSpecialModes();
  }
  return _createClass(LocalizationStore, [{
    key: "intl",
    get: function get() {
      return this._intl;
    }
  }, {
    key: "localeKey",
    get: function get() {
      return this._localeKey;
    }
  }, {
    key: "locale",
    get: function get() {
      return this._intl.locale;
    }
  }, {
    key: "messages",
    get: function get() {
      return this._intl.messages;
    }
  }, {
    key: "currencyFormatLocale",
    get: function get() {
      return this._currencyFormatLocale || getGlobalProperty("currencyFormatLocale") || this.locale;
    }
  }, {
    key: "intlForCurrency",
    get: function get() {
      // If currency locale is different than page locale, we need to create
      // a different intl object to use for formatting currencies
      if (this.locale !== this.currencyFormatLocale) {
        return createIntl({
          locale: this.currencyFormatLocale,
          messages: {}
        });
      }
      return this._intl;
    }
  }, {
    key: "shouldPassThrough",
    get: function get() {
      return this._shouldPassThrough;
    }
  }]);
}();
LocalizationStore.get = singletonGetter(LocalizationStore);